<app-trash />
<app-dark-mode-icon />
<app-clear />
<app-sound />
<app-particle [particlesComponent]="pariclesComponent()" />
